export default "__VITE_ASSET__5709e480__"